export default __webpack_public_path__ + "static/124-db9452194f36adf4d2565d11aaeb9c15.jpg";